module.exports = __webpack_public_path__ + "img/guibai.a44b4a7d.png";